import React from "react";
import styled from "styled-components";
import { Loading } from "../Loading";
const Styles = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0.2rem 0;
  .text-btn {
    cursor: pointer;
    width: calc(100%);
    padding: var(--fs-textfield) 1rem;
    border-radius: var(--border-radius-4);
    border: none;
    outline: none;
    transition: var(--trans-1);
    font-size: var(--fs-textfield);
    background-color: var(--prime-1);
    color: var(--n-grey-0);
    fill: var(--n-grey-0);
    display: flex;
    justify-content: center;
    gap: 0.3rem;
    svg {
      fill: var(--n-grey-0);
    }
    font-weight: 500;
    &.link {
      text-decoration: none;
      width: calc(100% - 2rem);
    }
    &.btn-type-1 {
      background-color: var(--n-primary-1-o);
      color: var(--n-primary-1);
      border: 1px solid var(--n-primary-1);
      :hover {
        background-color: var(--n-primary-1-o2);
      }
    }
    &.btn-type-2 {
      background-color: var(--n-primary-8);
      color: var(--n-grey-0);
      border: 1px solid var(--n-primary-8);
      :hover {
        background-color: var(--n-primary-82);
      }
    }
    &:hover {
      background-color: var(--prime-2);
    }
    &:disabled {
      background-color: var(--n-grey-1);
      color: var(--n-grey-3);
    }
  }
  .error {
    display: flex;
    height: 1rem;
    font-size: var(--fs-small);
    .icon {
      text-align: center;
      width: 1rem;
      height: 1rem;
    }
    .text {
      margin: 0 0.2rem 0 0;
    }
  }
  @media screen and (max-width: 1445px) {
    .text-field {
      padding: 0.7rem 1rem;
    }
  }
  @media screen and (max-width: 800px) {
  }
`;

export const TextBtn = ({
  style,
  className,
  classname,
  type,
  name,
  text,
  onclick,
  disabled,
  loading,
  newType1,
  newType2,
  link,
}) => {
  let classes = "text-btn";
  if(newType1) {
    classes+= " btn-type-1"
  }
  if(newType2) {
    classes+= " btn-type-2"
  }
  if (loading) {
    return (
      <Styles style={style}>
        <button
          type={type}
          className={classes + ' ' +className}
          name={name}
          onClick={onclick}
          disabled={disabled}
        >
          <Loading small={true}/>
        </button>
      </Styles>
    );
  }
  if(link){
    return (
      <Styles style={style}  className={classname}>
        <a
          type={type}
          className={classes + ' link'}
          name={name}
          disabled={disabled}
          href={link}
        >
          {text}
        </a>
      </Styles>
    );
  }
  return (
    <Styles style={style} className={classname}>
      <button
        type={type}
        className={classes}
        name={name}
        onClick={onclick}
        disabled={disabled}
      >
        {text}
      </button>
    </Styles>
  );
};
